module.exports = __webpack_public_path__ + "img/grey_041.ef963d83.png";